import { gql } from '@apollo/client';

export const TERMINE_TERMIN_CREATE = gql`
  mutation CreateTermin(
    $managerId: String!
    $termin: termine_terminCreateInput!
  ) {
    termine_terminCreate(managerId: $managerId, termin: $termin) {
      error {
        message
      }
      result {
        id
        titel
        datum
        beginn
        ende
        standortId
        terminKalenderId
        markierung
        wiederholung
        wiederholungBis
        termineDetails {
          beschreibung
          specials
        }
        image {
          name
          url
          thumbnailUrl
          contentType
        }
      }
    }
  }
`;

export const TERMINE_UPDATE_TERMIN = gql`
  mutation UpdateTermin(
    $managerId: String!
    $termin: termine_terminUpdateInput!
  ) {
    termine_terminUpdate(managerId: $managerId, termin: $termin) {
      error {
        message
      }
      result {
        beginn
        titel
        id
        wiederholung
        wiederholungBis
        datum
        ende
        image {
          contentType
          name
          thumbnailUrl
          url
        }
        markierung
        standortId
        terminKalenderId
        termineDetails {
          beschreibung
          specials
        }
        termine_arbeitszeiten {
          arbeitsbereich {
            id
            markierung
            name
          }
          beginn
          datum
          ende
          id
          mitarbeiter {
            bildUrl
            id
            nachname
            vorname
          }
        }
        termine_schichten {
          beginn
          datum
          ende
          id
          markierung
          name
          termine_arbeitsbereich {
            id
            markierung
            name
          }
          termine_mitarbeiter {
            bildUrl
            id
            nachname
            vorname
          }
        }
      }
    }
  }
`;

export const TERMINE_TERMIN_DELETE = gql`
  mutation DeleteTermin($managerId: String!, $idTerminDefinitionen: String!) {
    termine_terminDelete(
      managerId: $managerId
      idTerminDefinitionen: $idTerminDefinitionen
    ) {
      error {
        message
        ... on termine_terminDeleteManagerNotFoundError {
          managerId
        }
        ... on termine_terminDeleteTerminDefinitionNotFoundError {
          idTermin
        }
      }
      result {
        terminId
      }
    }
  }
`;
